module.exports = __webpack_public_path__ + "media/assets/icons/process-optimization-5bca2e8c428c373d58f2eb8967d17250.svg";